import React, { Component } from 'react';
import { connect } from 'react-redux';
import { i18n, getLocale } from 'core/i18n';
import SideMenu from 'components/sideMenu';
import Bookings from './bookings';
import Select from 'components/reactSelect';
import DatePicker from 'components/datePicker';
import Button from 'components/button';
import InputField from 'components/inputField';
import moment from 'moment';
import './home.css';
import {
  getPortalToken
} from './action';
import {
  getAllAgent
} from '../mainModule/action';

class HomeIndex extends Component {
  constructor(props) {
    super(props);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onOpenPassengerSelecter = this.onOpenPassengerSelecter.bind(this);
    this.onChangePassengerNumber = this.onChangePassengerNumber.bind(this);
    this.state = {
      searchRadio: localStorage.getItem('searchRadio') || 'roundTrip',
      openPassengerSelecter: false,
      adultNumber: 1,
      childrenNumber: 0,
      infantNumber: 0,
      beforeSelect: moment().toDate(),
      departureSegmentToOption: {
        'zh-tw': [],
        'jp': [],
        'kr': [],
        'th': [],
        'en': []
      },
      returnSegmentFromOption: {
        'zh-tw': [],
        'jp': [],
        'kr': [],
        'th': [],
        'en': []
      },
      returnSegmentToOption: {
        'zh-tw': [],
        'jp': [],
        'kr': [],
        'th': [],
        'en': []
      },
      selectSegmentErrorObject: {
        departureSegmentFrom: false,
        departureSegmentTo: false,
        returnSegmentFrom: false,
        returnSegmentTo: false
      }
    }
  }

  onRadioChange(event) {
    const self = this,
      { state } = self,
      { searchRadio } = state;
    if (searchRadio === 'multiCity') {
      event.currentTarget.value !== 'multiCity' && this.refs.departureSegmentTo.clearValue();
    } else {
      event.currentTarget.value === 'multiCity' && this.refs.departureSegmentTo.clearValue();
    }
    this.setState({
      searchRadio: event.currentTarget.value
    });
  }

  onSearch() {
    const {
      props,
      state,
      refs
    } = this,
    {
      dispatch
    } = props,
    {
      departureSegmentFrom,
      departureSegmentTo,
      returnSegmentFrom,
      returnSegmentTo,
      datePickerFrom,
      datePickerTo,
      promotionCode
    } = refs,
    {
      searchRadio,
      adultNumber,
      childrenNumber,
      infantNumber
    } = state;

    let urlParameter = '';
    switch (searchRadio) {
      case 'roundTrip':
        urlParameter += `&outbound=${departureSegmentFrom.getValue().value}-${departureSegmentTo.getValue().value}`;
        urlParameter += `&inbound=${departureSegmentTo.getValue().value}-${departureSegmentFrom.getValue().value}`;
        urlParameter += `&departureDate=${moment(datePickerFrom.getValue().selectedDay).format('YYYY-MM-DD')}`;
        urlParameter += `&returnDate=${moment(datePickerTo.getValue().selectedDay).format('YYYY-MM-DD')}`;
        this.setState({
          selectSegmentErrorObject: {
            departureSegmentFrom: !departureSegmentFrom.getValue(),
            departureSegmentTo: !departureSegmentTo.getValue()
          }
        });
        if (!departureSegmentFrom.getValue() || !departureSegmentTo.getValue()) {
          return;
        }
        break;
      case 'single':
        urlParameter += `&outbound=${departureSegmentFrom.getValue().value}-${departureSegmentTo.getValue().value}`;
        urlParameter += `&departureDate=${moment(datePickerFrom.getValue().selectedDay).format('YYYY-MM-DD')}`;
        this.setState({
          selectSegmentErrorObject: {
            departureSegmentFrom: !departureSegmentFrom.getValue(),
            departureSegmentTo: !departureSegmentTo.getValue()
          }
        });
        if (!departureSegmentFrom.getValue() || !departureSegmentTo.getValue()){
          return;
        }
        break;
      case 'multiCity':
        urlParameter += `&outbound=${departureSegmentFrom.getValue().value}-${departureSegmentTo.getValue().value}`;
        urlParameter += `&inbound=${returnSegmentFrom.getValue().value}-${returnSegmentTo.getValue().value}`;
        urlParameter += `&departureDate=${moment(datePickerFrom.getValue().selectedDay).format('YYYY-MM-DD')}`;
        urlParameter += `&returnDate=${moment(datePickerTo.getValue().selectedDay).format('YYYY-MM-DD')}`;
        this.setState({
          selectSegmentErrorObject: {
            departureSegmentFrom: !departureSegmentFrom.getValue(),
            departureSegmentTo: !departureSegmentTo.getValue(),
            returnSegmentFrom: !returnSegmentFrom.getValue(),
            returnSegmentTo: !returnSegmentTo.getValue()
          }
        });
        if (!departureSegmentFrom.getValue() || !departureSegmentTo.getValue() || !returnSegmentFrom.getValue() || !returnSegmentTo.getValue()) {
          return;
        }
        break;
      default:
        break;
    }
    urlParameter += `&type=${searchRadio}`;
    urlParameter += `&adult=${adultNumber}`;
    urlParameter += `&children=${childrenNumber}`;
    urlParameter += `&infant=${infantNumber}`;
    urlParameter += `&languageCode=${getLocale()}`;
    urlParameter += `&promoCode=${promotionCode.getValue()}`;
    urlParameter += `&currencyCode=${departureSegmentFrom.getValue().currencyCode}`;
    dispatch(getPortalToken('', 'ibe', urlParameter));
  }

  onOpenPassengerSelecter() {
    const { state } = this,
      { openPassengerSelecter } = state;
    this.setState({
      openPassengerSelecter: !openPassengerSelecter
    });
  }

  onChangePassengerNumber(type, value) {
    const { state } = this,
      {
        adultNumber,
        childrenNumber,
        infantNumber
      } = state;
    switch (type) {
      case 'adult':
        if (adultNumber === 1 && value === -1) {
          return;
        } else if (adultNumber === 9 && value === 1) {
          return;
        } else if (adultNumber + childrenNumber >= 9 && value === 1) {
          return;
        } else {
          this.setState({
            adultNumber: adultNumber + value
          });
          if (value === -1 && adultNumber <= infantNumber) {
            this.setState({
              infantNumber: adultNumber + value
            });
          }
        }
        break;
      case 'children':
        if (childrenNumber === 0 && value === -1) {
          return;
        } else if (childrenNumber === 9 && value === 1) {
          return;
        } else if (adultNumber + childrenNumber >= 9 && value === 1) {
          return;
        } else {
          this.setState({
            childrenNumber: childrenNumber + value
          });
        }
        break;
      case 'infant':
        if (infantNumber === 0 && value === -1) {
          return;
        } else if (infantNumber === 4 && value === 1) {
          return;
        } else if (adultNumber <= infantNumber && value !== -1) {
          return;
        } else {
          this.setState({
            infantNumber: infantNumber + value
          });
        }
        break;
      default:
        break;
    }
  }

  componentDidMount() {
    const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    dispatch(getAllAgent());
  }

  componentDidUpdate(prevProps) {
    const self = this,
      {
        props
      } = self,
      {
        state
      } = props;
    if (prevProps.state.action !== state.action) {
      switch (state.action) {
        case '':
          break;
        default:
          break;
      }
    }
  }

  render() {
    const self = this,
      {
        props,
        state: _state,
        onOpenPassengerSelecter,
        onChangePassengerNumber,
        onSearch
      } = self,
      {
        flightOptionObject,
        agentList,
        balanceInfo
      } = props,
      {
        searchRadio,
        openPassengerSelecter,
        adultNumber,
        childrenNumber,
        infantNumber,
        beforeSelect,
        departureSegmentToOption,
        returnSegmentFromOption,
        returnSegmentToOption,
        selectSegmentErrorObject
      } = _state;
    return (
      <div className='home-container'>
        {/* 左側 航班搜尋、近期訂位資料 */}
        <div className='area-left'>
          <div className='home-title'>
            {i18n('flight_search')}
          </div>
          {/* ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ 航班搜尋區塊 ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ */}
          <div className='home-airline-area'>
            <div className='home-radio-area'>
              <div>
                <input id='roundTrip' value='roundTrip' type='radio' name='searchRadio' checked={searchRadio === 'roundTrip'} onChange={this.onRadioChange} />
                <label htmlFor='roundTrip'>
                  {i18n('journey_return')}
                </label>
              </div>
              <div>
                <input id='single' value='single' type='radio' name='searchRadio' checked={searchRadio === 'single'} onChange={this.onRadioChange} />
                <label htmlFor='single'>
                  {i18n('journey_single')}
                </label>
              </div>
              <div>
                <input id='multiCity' value='multiCity' type='radio' name='searchRadio' checked={searchRadio === 'multiCity'} onChange={this.onRadioChange} />
                <label htmlFor='multiCity'>
                  {i18n('journey_multi')}
                </label>
              </div>
            </div>
            <div className='home-segment-container'>
              <div className='home-segment-item'>
                <div>
                  {i18n('origin')}
                </div>
                <img alt='' src={require('assets/images/take-off.svg')} />
                <Select
                  id='departureSegmentFrom'
                  ref='departureSegmentFrom'
                  onChangeEvent={(data) => {
                    let newOptionObject = JSON.parse(JSON.stringify(flightOptionObject));
                    let newReturnSegmentFromOptionObject = JSON.parse(JSON.stringify(flightOptionObject));
                    // 多城市邏輯：第一段台灣出發時，第二段出發必為非台灣出發，第二段回程必為台灣；第一段非台灣出發時，第一段回程必然為台灣，第二段出發必為台灣
                    Object.keys(newOptionObject).forEach((objectKey) => {
                      let selectArr = [];
                      newOptionObject[objectKey].forEach((key) => {
                        let optionsArr = [];
                        key.options.forEach((k) => {
                          data.markets.forEach((marketsKey) => {
                            if (marketsKey === k.value) {
                              optionsArr.push(k);
                            }
                          });
                        });
                        if (optionsArr.length !== 0) {
                          if (searchRadio === 'multiCity' && data.currencyCode !== 'TWD') {
                            if (key.code === 'TW') {
                              selectArr.push({
                                label: key.label,
                                options: optionsArr,
                                code: key.code
                              });
                            }
                          } else {
                            selectArr.push({
                              label: key.label,
                              options: optionsArr,
                              code: key.code
                            });
                          }
                        }
                      });
                      newOptionObject[objectKey] = selectArr;
                    });
                    this.setState({ departureSegmentToOption: newOptionObject });
                    // 第二段出發邏輯
                    Object.keys(newReturnSegmentFromOptionObject).forEach((objectKey) => {
                      newReturnSegmentFromOptionObject[objectKey].forEach((key, index) => {
                        if (data.currencyCode === 'TWD') {
                          key.code === 'TW' && delete newReturnSegmentFromOptionObject[objectKey][index];
                        } else {
                          key.code !== 'TW' && delete newReturnSegmentFromOptionObject[objectKey][index];
                        }
                      });
                    });
                    this.setState({ returnSegmentFromOption: newReturnSegmentFromOptionObject });
                    this.refs.departureSegmentTo.clearValue();
                    this.refs.returnSegmentFrom.clearValue();
                  }}
                  placeholder={i18n('placeholder_departure')}
                  defaultValue={''}
                  options={flightOptionObject[getLocale()]}
                  errorText={selectSegmentErrorObject.departureSegmentFrom}
                />
              </div>
              <div className='home-segment-item'>
                <div>
                  {i18n('destination')}
                </div>
                <img alt='' src={require('assets/images/landing.svg')} />
                <Select
                  id='departureSegmentTo'
                  ref='departureSegmentTo'
                  onChangeEvent={(data) => {
                  }}
                  placeholder={i18n('placeholder_return')}
                  defaultValue={''}
                  options={departureSegmentToOption[getLocale()]}
                  errorText={selectSegmentErrorObject.departureSegmentTo}
                />
              </div>
            </div>
            <div className='home-segment-container' style={{ display: searchRadio === 'multiCity' ? 'block' : 'none' }}>
              <div className='home-segment-item'>
                <div>
                  {i18n('origin')}
                </div>
                <img alt='' src={require('assets/images/take-off.svg')} />
                <Select
                  id='returnSegmentFrom'
                  ref='returnSegmentFrom'
                  onChangeEvent={(data) => {
                    let newReturnSegmentToOptionObject = JSON.parse(JSON.stringify(flightOptionObject));
                    Object.keys(newReturnSegmentToOptionObject).forEach((objectKey) => {
                      let selectArr = [];
                      newReturnSegmentToOptionObject[objectKey].forEach((key) => {
                        let optionsArr = [];
                        key.options.forEach((k) => {
                          data.markets.forEach((marketsKey) => {
                            if (marketsKey === k.value) {
                              optionsArr.push(k);
                            }
                          });
                        });
                        if (optionsArr.length !== 0) {
                          if (data.currencyCode !== 'TWD') {
                            if (key.code === 'TW') {
                              selectArr.push({
                                label: key.label,
                                options: optionsArr,
                                code: key.code
                              });
                            }
                          } else {
                            selectArr.push({
                              label: key.label,
                              options: optionsArr,
                              code: key.code
                            });
                          }
                        }
                      });
                      newReturnSegmentToOptionObject[objectKey] = selectArr;
                    });
                    this.setState({ returnSegmentToOption: newReturnSegmentToOptionObject });
                    this.refs.returnSegmentTo.clearValue();
                  }}
                  placeholder={i18n('placeholder_departure')}
                  defaultValue={''}
                  options={returnSegmentFromOption[getLocale()]}
                  errorText={selectSegmentErrorObject.returnSegmentFrom}
                />
              </div>
              <div className='home-segment-item'>
                <div>
                  {i18n('destination')}
                </div>
                <img alt='' src={require('assets/images/landing.svg')} />
                <Select
                  id='returnSegmentTo'
                  ref='returnSegmentTo'
                  placeholder={i18n('placeholder_return')}
                  defaultValue={''}
                  options={returnSegmentToOption[getLocale()]}
                  errorText={selectSegmentErrorObject.returnSegmentTo}
                />
              </div>
            </div>
            <div className='home-date-container'>
              <DatePicker
                ref='datePickerFrom'
                type={'single'}
                placeholder={i18n('departure_date')}
                frameStyle={{
                  flex: '1',
                  margin: searchRadio === 'single' ? '0' : '0 10px 0 0'
                }}
                defaultDate={moment().toDate()}
                selectedEvent={(day, selected) => {
                  this.setState({
                    beforeSelect: day
                  });
                  if (!selected) { //去程沒選擇時不重設回程
                    if (day > this.refs.datePickerTo.getValue().selectedDay) {
                      this.refs.datePickerTo.setDate(moment(day).add(3, 'days').toDate());
                    }
                  }
                }}
              />
              <DatePicker
                ref='datePickerTo'
                type={'single'}
                placeholder={i18n('return_date')}
                frameStyle={{
                  flex: '1',
                  display: searchRadio === 'single' ? 'none' : 'block'
                }}
                defaultDate={moment().toDate()}
                beforeSelect={beforeSelect}
              />
            </div>
            <div className='home-passenger-promotion-container'>
              <Button
                className='home-passenger'
                style={{ border: openPassengerSelecter ? '1px solid #faa835' : '1px solid #e6e7e8' }}
                onClick={onOpenPassengerSelecter}
              >
                <img alt='' src={require('assets/images/passenger.svg')} />
                <div>
                  {i18n('passengers')}
                </div>
                <div>
                  {`${adultNumber} ${i18n('adults')},${childrenNumber} ${i18n('children')},${infantNumber} ${i18n('infants')}`}
                </div>
              </Button>
              {
                openPassengerSelecter ? (
                  <div
                    className='home-passenger-mask'
                    onClick={onOpenPassengerSelecter}
                  />
                ) : null
              }
              {
                openPassengerSelecter ? (
                  <div
                    className='home-passenger-popup'
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  >
                    <div className='home-passenger-cell'>
                      <div className='home-passenger-cell-left'>
                        {i18n('adults')}
                        <br />
                        {i18n('tips_adults')}
                      </div>
                      <div className='home-passenger-cell-right'>
                        <div
                          className={adultNumber === 1 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('adult', -1); }}
                        >
                          -
												</div>
                        <div>
                          {adultNumber}
                        </div>
                        <div
                          className={adultNumber + childrenNumber >= 9 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('adult', 1); }}
                        >
                          +
												</div>
                      </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className='home-passenger-cell'>
                      <div className='home-passenger-cell-left'>
                        {i18n('children')}
                        <br />
                        {i18n('tips_children')}
                      </div>
                      <div className='home-passenger-cell-right'>
                        <div
                          className={childrenNumber === 0 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('children', -1); }}
                        >
                          -
												</div>
                        <div>
                          {childrenNumber}
                        </div>
                        <div
                          className={adultNumber + childrenNumber >= 9 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('children', 1); }}
                        >
                          +
												</div>
                      </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className='home-passenger-cell'>
                      <div className='home-passenger-cell-left'>
                        {i18n('infants')}
                        <br />
                        {i18n('tips_infants')}
                      </div>
                      <div className='home-passenger-cell-right'>
                        <div
                          className={infantNumber === 0 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('infant', -1); }}
                        >
                          -
												</div>
                        <div>
                          {infantNumber}
                        </div>
                        <div
                          className={adultNumber <= infantNumber || infantNumber === 4 ? 'home-passenger-button-disable' : ''}
                          onClick={() => { onChangePassengerNumber('infant', 1); }}
                        >
                          +
												</div>
                      </div>
                    </div>
                  </div>
                ) : null
              }
              <InputField
                className='home-promotion'
                ref='promotionCode'
                label='Label'
                placeholder={i18n('promo_code')}
                inputType='docNumber'
                maxLength='8'
              />
            </div>
            <Button
              className='home-search-button primary-button'
              onClick={onSearch}
            >
              <div>
                {i18n('search')}
              </div>
            </Button>
          </div>
          {/* ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ 航班搜尋區塊 ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ */}
          <div className='home-title'>
            {i18n('bookings_paid')}
          </div>
          <Bookings
            flightOptionObject={flightOptionObject[getLocale()]}
            agentList={agentList}
          />
        </div>
        <SideMenu
          balanceInfo={balanceInfo}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.homeReducer,
    lang: state.mainReducer.lang,
    flightOptionObject: state.mainReducer.flightOptionObject,
    agentList: state.mainReducer.agentList,
    balanceInfo: state.mainReducer.balanceInfo
  };
};

export default connect(mapStateToProps)(HomeIndex);